import { useApi } from 'ply-api'
import * as React from 'react'
import { useShallow } from 'zustand/shallow'
import { defaultEndpoints, defaultParseResponse } from './defaults'
import { makeCreateStore } from './store'
import type { AuthProviderProps, AuthProviderState, AuthUser } from './types'

const Context = React.createContext<ReturnType<
	ReturnType<typeof makeCreateStore>
> | null>(null)

function AuthProvider<User extends AuthUser = AuthUser>(
	props: AuthProviderProps<User>,
) {
	const { baseURL } = useApi()
	const [useStore] = React.useState(() =>
		makeCreateStore(
			baseURL,
			props.endpoints ?? defaultEndpoints,
			props.parseResponse ?? defaultParseResponse,
		)(),
	)

	return <Context.Provider value={useStore}>{props.children}</Context.Provider>
}

export function useAuth<U>(
	selector: (state: AuthProviderState<AuthUser>) => U,
): U {
	const useStore = React.useContext(Context)

	if (!useStore) {
		throw Error('useAuth must be used in an AuthProvider')
	}

	return useStore(useShallow(selector ?? ((s) => s)))
}

export { AuthProvider, AuthProvider as default }
